export const FORM_TEMPLATE = `
<div class="wm-form">
<h2 class="wm-form__heading">Contrate e comece a já poupar nas suas faturas de energia!</h2>
<p class="wm-form__tagline">
  É simples: insira o Código Mais Amigo e o seu contacto. Deixe o resto
  connosco.
</p>

<form class="wm-form__form" id="wm-form">
  <span class="wm-form__requiered_fields">*Campos obrigatórios</span>

  <section class="wm-form__fields">
    <div class="wm-form__field">
      <label class="wm-form__label" for="phone">
        Telefone<span class="wm-form__required">*</span>
      </label>
      <input class="wm-form__input" type="tel" id="phone" name="phone" />
    </div>

    <div class="wm-form__field">
      <label class="wm-form__label" for="phone">
        Código Promocional<span class="wm-form__required">*</span>
      </label>
      <input
        class="wm-form__input"
        type="text"
        id="promo-code"
        name="promo_code"
      />
    </div>
  </section>

  <label for="policy" class="wm-form__checbox">
    <input type="checkbox" id="policy" name="policy" value="true" required />
    <p>
      Autorizo a Iberdrola a recolher e utilizar os meus dados para
      comunicação de outras ofertas/campanhas comerciais.
      <a class="wm-form__policy" href="#">
        Ver política de privacidade.
        <span class="wm-form__required">*</span>
      </a>
    </p>
  </label>

  <button type="submit" class="wm-form__submit">Liguem-me</button>
</form>
</div>
`
